import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../services/UserService";
import { User } from "../../interfaces";

interface Users {
  users: User[];
  singleUser?: User;
  error?: string | null;
  loading: boolean;
}

const initialState: Users = {
  users: [],
  singleUser: {} as User,
  error: "",
  loading: false,
};

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await userService.getAll();
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const fetchUserById = createAsyncThunk(
  "users/fetchUserById",
  async (id: number) => {
    try {
      const response = await userService.getById(id);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const updateUserStatus = createAsyncThunk(
  "users/updateUserStatus",
  async ({ id, status }: { id: number; status: string }, { rejectWithValue }) => {
    try {
      const response = await userService.updateStatus(id, status);
      return { id, status: response.data.status };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      state.users = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.error = action.error.message || "";
      state.loading = false;
    });

    builder.addCase(fetchUserById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchUserById.fulfilled, (state, action) => {
      state.singleUser = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchUserById.rejected, (state, action) => {
      state.error = action.error.message || "";
      state.loading = false;
    });
  },
});

const { reducer } = userSlice;
export default reducer;
